import { ReactNode } from 'react';

interface Props {
  message: ReactNode | string;
  callToAction?: ReactNode;
}

export const Banner = ({ message, callToAction }: Props) => (
  <div className="font-semibold w-full border-2 border-alpineTeal text-center rounded-xl py-4 m-2">
    {message}
    {callToAction && <div className="mt-2">{callToAction}</div>}
  </div>
);
